import React from "react";
import { FaMoneyCheckAlt, FaCalendarCheck, FaShieldAlt } from "react-icons/fa";

const Features = () => {
  return (
    <section className="bg-white rounded-2xl shadow-lg p-10 md:p-14">
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Top Row */}
        <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-10 items-center text-left">
          <h2 className="text-4xl font-bold text-gray-900 leading-snug">
            Experience that grows with your scale.
          </h2>
          <p className="text-lg text-gray-600">
            Build a financial infrastructure that adapts to your business needs
            and simplifies cash flow at every stage.
          </p>
        </div>

        {/* Bottom Row */}
        <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Feature 1 */}
          <div className="flex flex-col gap-4">
            <FaMoneyCheckAlt className="text-teal-600 text-3xl" />
            <h3 className="text-xl font-semibold text-gray-800">
              Free Transfers
            </h3>
            <p className="text-gray-600 text-sm">
              Provide seamless money movement and optimize transactions without
              hidden fees. Enjoy instant transfers to domestic and international
              accounts, ensuring your funds arrive quickly and securely every
              time.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="flex flex-col gap-4">
            <FaCalendarCheck className="text-teal-600 text-3xl" />
            <h3 className="text-xl font-semibold text-gray-800">
              Scheduled Payments
            </h3>
            <p className="text-gray-600 text-sm">
              Automate recurring payments and streamline operations with smart
              scheduling. Set up flexible payment intervals, get reminders, and
              manage subscriptions effortlessly to keep your business cash flow
              predictable and smooth.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="flex flex-col gap-4">
            <FaShieldAlt className="text-teal-600 text-3xl" />
            <h3 className="text-xl font-semibold text-gray-800">
              Secure by Design
            </h3>
            <p className="text-gray-600 text-sm">
              Keep your business safe with built-in security protocols and fraud
              protection. Benefit from advanced encryption, multi-factor
              authentication, and continuous monitoring to protect your
              transactions and sensitive data against threats.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
